import { layout } from 'src/styles/layout';
import styled from 'styled-components';

export const HeroTypeInContainer = styled.div`
  max-width: 960px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  row-gap: 1.5rem;

  .hero-paragraph {
    max-width: 815px;
  }

  .link-branded {
    max-width: 190px;
    width: 100%;
  }

  // Needed to avoid highlighted TypeIn text jumping on new line
  @media all and (max-width: ${layout.lg}) {
    max-width: 840px;
  }

  @media all and (max-width: ${layout.md}) {
    max-width: 720px;
  }
`;
